// extracted by mini-css-extract-plugin
export default {"settings-button":"LayersSidebar_settings-button__sp3H6","drawer":"LayersSidebar_drawer__+NqOv"};